import { Icon } from '../UI';
import TooltipIcon from '../InfoTooltip/Tooltip-icon';
import { Cancel } from './Cancel';
import { useNewStrategyContext } from './NewStrategyContext';
import { ProgressNav } from './ProgressNav';
import { Skip } from './Skip';

export const Nav = () => {
  const {
    confirmElement,
    isTooltipIconVisible,
    currentStep,
    newStrategy,
    title,
    dispatch,
  } = useNewStrategyContext();

  const isOpenConfirmCloseModal = typeof confirmElement !== 'undefined';

  return (
    <nav
      className={`
          flex
          w-full
          h-20
          items-center
          justify-between
          shadow-lg
          text-black
          dark:bg-grey-90
          dark:border-grey-80
          border-b
          border-transparent
          dark:border-grey-70
          relative
        `}
    >
      <span
        className={`
            flex
            items-center
            ${currentStep && 'border-b-4 border-primary'}
            h-full
            px-4
          `}
      >
        <Icon
          svgName="merlinLogo"
          className={`${isOpenConfirmCloseModal && 'text-lime z-60'}`}
        />
      </span>

      {!currentStep ? (
        <div className="-ml-32 text-lg font-medium dark:text-white">
          {title}
        </div>
      ) : (
        <ProgressNav />
      )}

      <div className="flex h-full items-center ">
        <TooltipIcon
          tooltipIconColor={`${!isTooltipIconVisible && 'grey-50'}`}
          tooltipIconClassname={`
                border-l
                border-r
                border-b
                border-grey-10
                px-6
                h-full
                dark:border-grey-80
              `}
          onClick={() =>
            dispatch({ isTooltipIconVisible: !isTooltipIconVisible })
          }
        />
        <div className="px-6">
          <Icon
            className="cursor-pointer"
            onClick={() =>
              dispatch({
                confirmElement:
                  currentStep && newStrategy.strategyId ? <Skip /> : <Cancel />,
              })
            }
            svgName="close"
          />
        </div>
      </div>
    </nav>
  );
};
